import axios from 'axios';
import { CommonRootState } from '../combineReducers';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';
import { QueryBuilder } from '@pec/aion-ui-odata/builders/odataQueryBuilder';
import { OdataComparator } from '@pec/aion-ui-odata/types/odataComparator';

export const fetchIncomingSubcontractRequestsCountSuccess = (payload: number) =>
  ({
    type: 'FETCH_INCOMING_SUBCONTRACT_REQUESTS_COUNT_SUCCESS',
    payload
  } as const);

export const fetchIncomingSubcontractRequestsCount = (
  organizationId: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    const { Equals } = OdataComparator;
    const odataParams = new QueryBuilder().filter(f => f.filterBy('requestStatus', Equals, 'Pending')).toQueryParam();
    const { data } = await axios.get<{ '@odata.count': number }>(
      '/api/v3.01/subcontractorManagement/subcontractRequests',
      {
        params: {
          ...odataParams,
          $top: 0,
          recipientOrganizationId: organizationId
        }
      }
    );

    dispatch(fetchIncomingSubcontractRequestsCountSuccess(data['@odata.count']));
  } catch (error) {
    sendError(error);
  }
};

export type Actions = ReturnType<typeof fetchIncomingSubcontractRequestsCountSuccess>;
